// Gate only the visualization, never the recorded audio.
export function microphoneIsQuiet(samples) {
  if (!samples.length) return true;
  const power = samples.reduce((sum, sample) => sum + ((sample - 128) / 128) ** 2, 0);
  return Math.sqrt(power / samples.length) < 0.012;
}

export function voiceBarLevel(frequency, quiet) {
  return quiet ? 0 : Math.max(0, (frequency - 20) / 235);
}
